import { createTypes } from './createTypes';

export default createTypes(
  'SYNC_RESET_LOCATION_CSV',
  'SYNC_RESET_MERCHANT_LOCATIONS',
  'GET_MECHANT_LOCATIONS',
  'VERIFY_LOCATION_CSV',
  'ADD_LOCATION_CSV'
);
